<template>
  <div class="terminologies">
    <div class="columns is-multiline is-centered">
      <div class="column is-6">
        <terminology-table-generic
          @created="onTableGenericCreated"
          @updated="onTableGenericUpdated"
        />
      </div>
      <div class="column is-6">
        <terminology-table-custom
          ref="tableCustom"
          @updated="onTableCustomUpdated"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TerminologyTableCustom from "@/components/Terminology/TerminologyTableCustom";
import TerminologyTableGeneric from "@/components/Terminology/TerminologyTableGeneric";

export default {
  components: {
    TerminologyTableCustom,
    TerminologyTableGeneric
  },
  methods: {
    setLocaleMessage(locale, terminology) {
      const message = this.$i18n.messages[locale] || {};
      this.$i18n.setLocaleMessage(locale, {
        ...message,
        [terminology.key]: terminology.value
      });
    },
    onTableGenericCreated(terminology) {
      this.$refs.tableCustom.fetch();
      this.setLocaleMessage("generic", terminology);
    },
    onTableGenericUpdated(terminology) {
      this.setLocaleMessage("generic", terminology);
    },
    onTableCustomUpdated(terminology) {
      this.setLocaleMessage("custom", terminology);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Terminology/Terminology.vue